import React from 'react'
import { useSelector } from 'react-redux'
import "./DetectLoader.scss"
const DetectLoader = () => {
    const loadingMsg = useSelector(state => state.loader.loadingMsg)
  return (
    <div className="detectLoaderWrapper">
        <div className="detectLoaderContainer">
            <object className="detectLoaderImg"  aria-label="svg animtaed picture" data="./brain.svg" type="image/svg+xml"></object> 
            <p className="detectLoaderText">{loadingMsg ? loadingMsg: "Loading..." }</p>
        </div>
    </div>
  )
}

export default DetectLoader